import { combineReducers } from "@reduxjs/toolkit"
import recordingReducers from './recording'
export default combineReducers({
    recording: recordingReducers
})